class TabCategoryBlocks {
  constructor(root) {
    this.root = root;
    this.tabs = [...root.querySelectorAll('[data-tab-cat-tab]')];
    this.panels = [...root.querySelectorAll('[data-tab-cat-panel]')];
    this.prevButton = root.querySelector('[data-tab-cat-prev]');
    this.nextButton = root.querySelector('[data-tab-cat-next]');
    if (!this.tabs.length || !this.panels.length) return;

    this.#bindEvents();
    this.#bindArrowEvents();
    this.#setupCardVideos();
    this.#syncFromUrl();
  }

  #bindEvents() {
    for (const tab of this.tabs) {
      tab.addEventListener('click', () => {
        this.#activateTab(tab);
      });

      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const currentIndex = this.tabs.indexOf(tab);
        const nextIndex = (currentIndex + direction + this.tabs.length) % this.tabs.length;
        this.tabs[nextIndex].focus();
        this.#activateTab(this.tabs[nextIndex]);
      });
    }
  }

  #bindArrowEvents() {
    if (!this.prevButton || !this.nextButton) return;

    this.prevButton.addEventListener('click', () => {
      this.#activateAdjacentTab(-1);
    });

    this.nextButton.addEventListener('click', () => {
      this.#activateAdjacentTab(1);
    });
  }

  #activateAdjacentTab(direction) {
    const activeIndex = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
    const nextIndex = (activeIndex + direction + this.tabs.length) % this.tabs.length;
    this.#activateTab(this.tabs[nextIndex]);
  }

  #activateTab(tab) {
    const panelId = tab.dataset.tabCatTab;

    for (const currentTab of this.tabs) {
      const isActive = currentTab === tab;
      currentTab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      currentTab.classList.toggle('is-active', isActive);
    }

    for (const panel of this.panels) {
      const isActive = panel.dataset.tabCatPanel === panelId;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    }

    tab.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest',
    });

    const nextUrl = new URL(window.location.href);
    nextUrl.searchParams.set('tab', panelId);
    window.history.replaceState({}, '', nextUrl);
  }

  #syncFromUrl() {
    const tabFromUrl = new URLSearchParams(window.location.search).get('tab');
    if (!tabFromUrl) return;

    const matchingTab = this.tabs.find((tab) => tab.dataset.tabCatTab === tabFromUrl);
    if (matchingTab) this.#activateTab(matchingTab);
  }

  #setupCardVideos() {
    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    for (const card of this.root.querySelectorAll('.tab-cat__card--with-video')) {
      const image = card.querySelector('.tab-cat__card-image--with-video');
      const video = card.querySelector('.tab-cat__card-video');
      const mediaLink = card.querySelector('.tab-cat__card-media-link');

      if (!image || !video || !mediaLink) continue;

      video.loop = false;
      video.muted = true;
      video.playsInline = true;

      card.addEventListener('mouseenter', () => {
        image.style.opacity = '0';
        video.play();
      });

      video.addEventListener('ended', () => {
        image.style.opacity = '1';
      });

      if (!isTouch) continue;

      card.addEventListener('click', (event) => {
        if (event.target.closest('form') || event.target.closest('.tab-cat__card-cta')) return;

        if (card.dataset.videoPreviewed !== 'true') {
          event.preventDefault();
          image.style.opacity = '0';
          video.currentTime = 0.15;
          video.play();
          card.dataset.videoPreviewed = 'true';
          return;
        }

        mediaLink.click();
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  for (const root of document.querySelectorAll('[data-tab-cat]')) {
    new TabCategoryBlocks(root);
  }
});

document.addEventListener('shopify:section:load', (event) => {
  const root = event.target.querySelector('[data-tab-cat]');
  if (root) new TabCategoryBlocks(root);
});
